import React from 'react';
import { connect, type ConnectedProps } from 'react-redux';
import type { ThunkDispatch } from 'redux-thunk';
import type { AnyAction } from 'redux';

import Animation from 'app/shared/modules/Animation';
import animationData from 'images/animations/alertAnimation.json';
import AppActions from 'app/shared/flux/actions/AppActions';
import Button from 'app/shared/core/Button';
import './style.scss';
import { emitTrackOpenSearchAlertModalEvent } from 'app/shared/models/Clickstream/SearchAlertEvents';

const connector = connect();

type PropsFromRedux = ConnectedProps<typeof connector>;

type AlertButtonProps = PropsFromRedux & {
  isMobileFilter?: boolean;
};

class AlertButton extends React.Component<AlertButtonProps> {
  static defaultProps = {
    isMobileFilter: false,
  };

  handleCreateSearchAlert = () => {
    const { dispatch } = this.props;
    emitTrackOpenSearchAlertModalEvent();
    (dispatch as ThunkDispatch<unknown, unknown, AnyAction>)(AppActions.toggleOverlay('createSearchAlert', true));
  };
  render() {
    return (
      <Button id="AlertButton" btnType="secondary" onClick={this.handleCreateSearchAlert} size="sm">
        <Animation
          aria-hidden="true"
          className="AlertButton-icon"
          shouldLoop
          shouldAutoplay
          animationData={animationData}
        />
        Get alerts
      </Button>
    );
  }
}

export default connector(AlertButton);
